import React from "react";
import "./TermsOfService.scss";

const TermsOfService: React.FC = () => {
  return (
    <main id="terms-of-service" className="terms-of-service">
      <h1>Terms of Service</h1>
      <p className="effective-date">Effective date: May 7, 2026</p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By downloading, installing, or using Mindara ("the App"), you agree to
        these Terms of Service ("Terms"). If you do not agree, do not use
        Mindara. These Terms form a binding agreement between you and Mindara
        ("we", "our", "us").
      </p>

      <h2>2. Service Description</h2>
      <p>
        Mindara is an AI-powered social planning platform that helps you
        discover venues, create evening plans, invite friends, coordinate RSVPs,
        and book restaurant reservations via Resy. The App is available on iOS
        only at this time.
      </p>

      <h2>3. Account Registration</h2>
      <p>
        You must create an account to use Mindara. You may sign in with Apple or
        Google. You are responsible for maintaining the security of your account
        credentials and for all activity under your account. You must be at
        least 13 years old to create an account.
      </p>

      <h2>4. Subscriptions and Billing</h2>
      <p>
        Mindara offers a free trial period followed by a paid Mindara Premium
        subscription. Subscriptions are managed through Apple In-App Purchase.
      </p>
      <ul>
        <li>
          Subscription pricing and duration are shown at the time of purchase in
          the App.
        </li>
        <li>
          Payment is charged to your Apple ID account at confirmation of
          purchase.
        </li>
        <li>
          Your subscription automatically renews unless you cancel at least 24
          hours before the end of the current subscription period.
        </li>
        <li>
          You can manage or cancel your subscription at any time in App Store
          Settings → Subscriptions.
        </li>
        <li>
          Any unused portion of a free trial period is forfeited when you
          purchase a subscription.
        </li>
        <li>
          Apple's standard App Store billing terms govern all in-app purchases.
          We do not process payments directly.
        </li>
      </ul>

      <h2>5. User Conduct</h2>
      <p>You agree not to:</p>
      <ul>
        <li>
          Use Mindara for any unlawful purpose or in violation of any applicable
          law
        </li>
        <li>
          Attempt to reverse engineer, decompile, or extract source code from
          the App
        </li>
        <li>
          Use automated tools (bots, scrapers) to access Mindara's API or data
        </li>
        <li>
          Impersonate another person or provide false information when creating
          an account
        </li>
        <li>Use Mindara to harass, abuse, or harm other users</li>
      </ul>

      <h2>6. User-Generated Content</h2>
      <p>
        You may create plans, add activities, and invite friends through
        Mindara. You retain ownership of any content you create. By using
        Mindara, you grant us a limited license to store and display your
        content within the App to provide the service. We do not claim ownership
        of your plans or data.
      </p>

      <h2>7. Third-Party Services</h2>
      <p>
        Mindara integrates with third-party services including Resy
        (reservations) and Google (authentication). Your use of these services
        is subject to their respective terms of service and privacy policies. We
        are not responsible for the practices of third-party services.
      </p>

      <h2>8. Intellectual Property</h2>
      <p>
        The Mindara app, its design, logo, and underlying technology are owned
        by Mindara and protected by applicable intellectual property laws. You
        may not reproduce, modify, or distribute any part of Mindara without our
        prior written consent.
      </p>

      <h2>9. Account Termination</h2>
      <p>
        You may delete your account at any time via Settings → Account → Delete
        Account in the App. Deletion is permanent and processes within 30 days.
        We reserve the right to suspend or terminate accounts that violate these
        Terms. Upon termination, your right to use the App ceases immediately.
      </p>

      <h2>10. Disclaimer of Warranties</h2>
      <p>
        Mindara is provided "as is" without warranties of any kind, express or
        implied. We do not guarantee that the App will be error-free,
        uninterrupted, or that venue information and reservation availability
        will always be accurate. Venue information is provided by third parties
        and may change without notice.
      </p>

      <h2>11. Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, Mindara and its team will not be
        liable for any indirect, incidental, special, or consequential damages
        arising from your use of the App, including but not limited to missed
        reservations, venue closures, or data loss. Our total liability to you
        for any claim arising from these Terms or your use of Mindara shall not
        exceed the amount you paid us in subscription fees in the 12 months
        prior to the claim.
      </p>

      <h2>12. Governing Law</h2>
      <p>
        These Terms are governed by the laws of the State of California, without
        regard to conflict of law principles. Any disputes arising under these
        Terms shall be resolved in the state or federal courts located in San
        Francisco County, California.
      </p>

      <h2>13. Changes to Terms</h2>
      <p>
        We may update these Terms from time to time. We will notify you of
        material changes via the App or by email. Continued use of Mindara after
        changes take effect constitutes your acceptance of the revised Terms.
      </p>

      <h2>14. Contact</h2>
      <p>
        For questions about these Terms, contact us at:{" "}
        <a href="mailto:legal@mindara.io">legal@mindara.io</a>
      </p>

      <p className="last-updated">Last updated: May 7, 2026</p>
    </main>
  );
};

export default TermsOfService;
